export default "__VITE_ASSET__YuikA7bx__"